import TypeScaleTable from '../../../../src/components/TypeScaleTable';
import TypeWeight from '../../../../src/components/TypeWeight';
import React from 'react';
export default {
  TypeScaleTable,
  TypeWeight,
  React
};